'use client';

import { startTransition, useDeferredValue, useEffect, useState } from 'react';
import { countTextTokens } from './countTextTokens';

export function useCodeTokenCount(code: string) {
  const deferredCode = useDeferredValue(code);
  const [tokenCount, setTokenCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;

    void countTextTokens(deferredCode)
      .then((nextCount) => {
        if (cancelled) return;
        startTransition(() => setTokenCount(nextCount));
      })
      .catch((error) => {
        if (cancelled) return;
        console.error('Failed to count A2UI preview tokens:', error);
        startTransition(() => setTokenCount(0));
      });

    return () => {
      cancelled = true;
    };
  }, [deferredCode]);

  return tokenCount;
}
